import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, borderRadius, colors, typography, spacing } = useTheme();

  return {
    base: css`
      height: 100%;
      display: grid;
      grid-template-rows: auto 1fr;
      grid-template-columns: 100%;
    `,
    hero: css`
      h1 {
        text-transform: capitalize;
        font-style: italic;
        text-align: center;
        font-size: 2.3125rem;
        font-family: 'FS Dillon';
        letter-spacing: 0.0022em;

        &::after {
          background: none;
        }

        ${breakpoints.l} {
          ${typography.headings[3].desktop};
          max-width: 100%;
          text-align: center;
          width: 85%;
          margin: 0 auto;
          font-family: 'FS Dillon';
          font-size: 4.625rem;
          letter-spacing: 0.0022em;
          line-height: 4.55rem;
        }
      }
    `,
    card: css`
      position: relative;
      background-color: ${colors.white};
      border-radius: ${borderRadius.l};
      margin-bottom: ${spacing.m};
      box-shadow: 0px 4px 6px rgba(91, 104, 133, 0.1);

      ${breakpoints.xl} {
        grid-template-rows: unset;
        grid-gap: ${spacing.s};
      }
    `,
    navContent: currentPage => css`
      padding: ${spacing.m};
      // &:not(:last-child) {
      //   border-bottom: 1px solid ${colors.lightGrey};
      // }

      ${breakpoints.mm_xl_xxl} {
        margin: -2.5rem auto;
        padding: 2rem 0;
      }

      &.aboutDetails {
        @media screen and (min-width: 1601px) {
          margin-top: ${(currentPage === 'teampage') ? '0' : '-2.8rem'};
          margin-bottom: -2.5rem;
        }
        ${breakpoints.mm_xl_xxl} {
          margin-top: -40px;
          padding: 1.5rem 0 2rem;
        }
        ${breakpoints.mm_l_xl} {
          padding: 0 2rem;
          margin-bottom: -8px;
          margin-top: -16px;
        }
        ${breakpoints.mm_m_l} {
          padding: 0 2rem;
          margin: 32px 0 -7px;
        }
        ${breakpoints.mm_s_m} {
          padding: 0 2rem;
          margin: -60px 0 -7px;
        }
        ${breakpoints.mm_xs_s} {
          padding: auto 2rem;
          margin: -20px 0 -40px;
        }
      }

      &.teamListDetails {
        margin-top: -44px;
        margin-bottom: -24px;
        ${breakpoints.mm_l_xl} {
          margin-top: 0;
          margin-bottom: -24px;
        }
        ${breakpoints.mm_m_l} {
          margin-top: 15px;
          margin-bottom: -20px;
        }
        ${breakpoints.mm_s_m} {
          margin-top: 15px;
          margin-bottom: -15px;
        }
        ${breakpoints.mm_xs_s} {
          margin-top: 0;
          margin-bottom: -15px;
        }
      }

      &.contactDetails {
        ${breakpoints.mm_xl_xxl} {
          margin: 0 auto;
        }
        ${breakpoints.mm_l_xl} {
          margin: 0 auto;
        }
        ${breakpoints.mm_m_l} {
          margin: 0 auto;
        }
        ${breakpoints.mm_s_m} {
          margin: 0 auto;
        }
        ${breakpoints.mm_xs_s} {
          margin: 0 auto;
        }
      }
    `,
    arrowRotate: css`
      transform: rotate(180deg);
      margin-right: 0.3125rem;
      color: ${colors.navy};
    `,
    backLink: css`
      color: ${colors.darkGrey};
      margin: ${spacing.s} 0;
      text-decoration: none;
      display: inline-block;
      font-weight: normal;
      padding: 0;
    `,
    loader: css`
      padding: ${spacing.s};
    `,
  };
};